module.exports = __webpack_public_path__ + "img/imgMemberW.f33e74f4.svg";